var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAutomatic(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 167,
    height: 45,
    viewBox: "0 0 167 45",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.0242 22.4532C65.0242 20.1623 63.3654 18.1987 60.2966 18.1987C57.2279 18.1987 55.5691 20.2441 55.5691 22.4532V22.6987C55.5691 24.9896 57.2279 27.0351 60.2966 27.0351C63.3654 27.0351 65.0242 24.9896 65.0242 22.6987V22.4532ZM60.2967 28.9168C56.0668 28.9168 53.3298 25.8896 53.3298 22.7805V22.4532C53.3298 19.2623 56.0668 16.3168 60.2967 16.3168C64.5266 16.3168 67.2636 19.2623 67.2636 22.4532V22.8623C67.2636 25.9714 64.5266 28.9168 60.2967 28.9168Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.29858 19.0169L4.72747 23.9259H10.0356L7.29858 19.0169ZM12.5238 28.5078L10.9479 25.6441H3.89813L2.40523 28.5078H0L6.46924 16.726H8.2939L14.8461 28.426H12.5238V28.5078Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.1054 28.9636C20.7925 28.9636 18.802 26.6727 18.802 23.6454V16.7727H21.0414V23.6454C21.0414 25.7727 22.5343 27.0818 25.2712 27.0818C28.0912 27.0818 29.2523 25.7727 29.2523 23.6454V16.7727H31.4917V23.6454C31.4917 26.5091 29.5841 28.9636 25.1054 28.9636Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.9325 18.5727V28.4727H41.6932V18.5727H36.468V16.7727H49.1577V18.5727H43.9325Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M87.2266 28.4727V19.2273L86.646 20.2091L81.6697 28.4727H80.5915L75.6152 20.2091L75.0346 19.2273V28.4727H72.8782V16.7727H75.9469L80.6744 24.7909L81.1721 25.7727L81.7526 24.7909L86.3972 16.7727H89.466V28.4727H87.2266Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M101.326 19.0636L98.7553 23.9727H104.063L101.326 19.0636ZM106.469 28.4727L104.893 25.6091H97.843L96.3501 28.4727H93.9448L100.414 16.7727H102.239L108.791 28.4727H106.469Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M117.914 18.5727V28.4727H115.675V18.5727H110.449V16.7727H123.139V18.5727H117.914Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M134.336 18.5727V28.4727H132.097V18.5727H126.872V16.7727H139.561V18.5727H134.336Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M145.118 28.4727V17.8364C146.03 17.8364 146.362 17.3455 146.362 16.6909H147.274V28.3909H145.118",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M164.857 20.0455C163.779 19.0636 162.203 18.1636 160.047 18.1636C156.895 18.1636 155.071 20.2909 155.071 22.5818V22.8273C155.071 25.0364 156.895 27.0818 160.213 27.0818C162.203 27.0818 163.862 26.1818 164.857 25.2L166.184 26.5909C164.857 27.8182 162.618 28.9636 160.047 28.9636C155.568 28.9636 152.748 26.1 152.748 22.9091V22.5C152.748 19.3091 155.734 16.3636 160.13 16.3636C162.618 16.3636 164.94 17.4273 166.184 18.7364L164.857 20.0455Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61.7644 20.3727C62.1791 20.6182 62.262 21.1909 62.0132 21.5182L59.9397 24.6272C59.6909 25.0363 59.1104 25.1182 58.6957 24.8727C58.281 24.6272 58.198 24.0545 58.4468 23.7272L60.5203 20.6182C60.8521 20.2909 61.3497 20.1272 61.7644 20.3727Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAutomatic);
export default __webpack_public_path__ + "static/media/automatic.9fa13be7d60fce0d3470719a543118b7.svg";
export { ForwardRef as ReactComponent };